import gql from 'graphql-tag';

export default gql`
  mutation updateAgentsTiersMutation($input: UpdateAgentsTiersInput) {
    agentsTiersUpdate(input: $input)
  }
`;
